/**
 * teamTags - fresh team tags for one change (a split, in the session's Teams dialog and the library's Teams view).
 * Minted here, never in the engine, which does not reach for the clock (gotcha 5). ONE stamp per change: a split
 * mints once per member, so a clock read per call could give two wearers of one name two different tags.
 */
import { teamTag } from '../engine/roster/team';

/** A minter for one change: index -> tag, the same index always the same tag. */
export function tagMinter(now: number = Date.now()): (i: number) => string {
  const stamp = now.toString(36);
  return (i) => teamTag(`${stamp}-${i}`)!;
}
